export const setSiteUpdateConnection = (data: any) => ({
  type: "SET_SITE_UPDATE_CONNECTION",
  payload: data,
});
